import styled from "styled-components"
import { colors } from "../../components/colors/colors"
export const ProjectContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 100px 1fr;
  grid-gap: 10px;
  background: ${colors.black};
  color: ${colors.white};

  @media (min-width: 375px) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`
